import { OperationModel } from "../../models/operations/operationModel";
import IOperationService from "../../services/operations/IOperationService";
import IAlertService from "../../services/alert/IAlertService";
import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import { decodeXml } from "../../utilities/index";
import Vue from "vue";

/**Модель представления операции */
export class OperationVue extends Vue {
  /**Признак валидности формы */
  public isValid: boolean = true;

  /**Признак ассайна */
  public assignProcess: boolean = false;

  /**Запустить prepare после assing */
  public prepareAfterAssing: boolean = false;

  /**Признак загрузки execute или prepare */
  public execLoading: boolean = false;

  /** Модель операции */
  public OperationModel: OperationModel = new OperationModel();

  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  get operPicture(): string {
    return this.OperationModel.Picture ?? "";
  }
  /**Показывать детали операции во время подтверждения */
  get needInfoBeforeExecute(): boolean {
    return this.OperationModel?.IsNeedInfoBeforeExecute ?? false;
  }

  /**Признак необходимости подтверждения операции */
  get needConfirm(): boolean {
    return this.OperationModel?._isNeedConfirm ?? false;
  }

  get caption(): string {
    return this.OperationModel?.Caption ?? "";
  }

  /**Подсказка к операции */
  get description(): string {
    return this.OperationModel?.Description ?? "";
  }

  get isInit(): boolean {
    return this.OperationModel?.IsInit ?? false;
  }

  get isConfirm(): boolean {
    return this.OperationModel?.IsConfirm ?? false;
  }

  get isSuccess(): boolean {
    return this.OperationModel?.IsSuccess ?? false;
  }

  /**Стиль статуса запроса */
  get requestStateStyle(): string {
    return this.OperationModel?.requestStateStyle ?? "";
  }

  /**Текстовый статус запроса */
  get stringRequestState(): string {
    return this.OperationModel?.stringRequestState ?? "";
  }

  /**Список информации */
  get details(): Array<any> {
    return this.OperationModel?.details ?? [];
  }

  /**Признак загрузки страницы */
  public loading: boolean = true;

  /**Сервис проведения операций каталога */
  public service!: IOperationService;

  /**Следующий шаг операции */
  async next(): Promise<void> {
    if (this.execLoading)
      return;
    try {
      if (this.assignProcess) {
        this.prepareAfterAssing = true;
        return;
      }

      this.validateForm();
      if (this.isValid) {
        this.execLoading = true;
        if (this.OperationModel.IsConfirm && this.needConfirm && !this.OperationModel.VerifyCode.length) {
          this.alertService.warning('Заполните поле: "Код подтверждения"');
          this.execLoading = false;
          return;
        }
        this.OperationModel = await this.service.nextStep(this.OperationModel);

        if (this.OperationModel.propertyErrorsComes) {
          this.validateForm();
          this.scrollToTop();
          this.execLoading = false;
          return;
        }

        if (this.OperationModel.IsSuccess || this.OperationModel.IsExecuting || this.OperationModel.IsError) {
          await this.service.afterExecute(this.OperationModel);
          await this.afterExecute();
        }
        this.execLoading = false;
      } else {
        this.scrollToTop();
      }
    }
    catch (e) {
      this.prepareAfterAssing = false;
      this.execLoading = false;
      this.scrollToTop();
      throw e;
    }
  }

  scrollToTop(): void {
    const elem: any = document.getElementById('form-start');
    if (elem) {
      elem.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
      });
    }    
  }

  /**Вернуться на предыдущий шаг */
  async back() {
    this.OperationModel = await this.service.back(this.OperationModel);
  }
  /**
   * Повтор кода подтверждения
   * */
  get repeatCode(): () => void {
    return async () => {
      await this.service.repeatConfirmCode(this.OperationModel.OperationId);
    };
  }

  validateForm(): void {
    try {
      this.isValid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
    } catch (e) {
      console.log("this.$refs.form.validate()", e);
    }
  }
  resetFormValidation(): void {
    try {
      (this.$refs.form as Vue & {
        resetValidation: () => boolean;
      }).resetValidation();
    } catch (e) {
      console.log("this.$refs.form.resetValidation()", e);
    }
  }

  /**Инициализация формы */
  async init(): Promise<void> {
    await this.initOperation();
  }
  /**Инициализация операции */
  async initOperation(): Promise<void> {
    this.OperationModel = await this.service.init();
    this.loading = false;
  }

  /**Метод для выполнения после успешного проведения */
  async afterExecute(): Promise<void> {
    await this.destroyForm();
  }

  /**Метод для очистки формы */
  async clearForm(): Promise<void> {
    this.OperationModel = new OperationModel();
  }

  /**Закрытие формыы */
  async destroyForm(): Promise<void> {
    await this.clearForm();
    this.$emit("hideSelf");
  }

  /**Признак видимости блока информации */
  infoVisible: boolean = false;

  /**Текст информации */
  infoText: string = "";

  /**Показать инфомрацию */
  showInfo(text: string): void {
    this.infoVisible = true;
    this.infoText = decodeXml(text.replace(/\n/g, "<br>"));
  }

  /**Скрыть информацию */
  closeInfo(): void {
    this.infoVisible = false;
    this.infoText = "";
  }
}
